import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';

type Params = {
  country?: string;
  juniorAgId?: string;
};

export type CollectionsDueResponse = {
  dueStatus: string;
  remainingBalance: number;
};

const useDueSummaryQuery = (params?: Params) => {
  const queryParams = useMemo(
    () => ({
      'country.equals': params?.country,
    }),
    [params],
  );
  const query = useQuery<AxiosResponse<CollectionsDueResponse[]>>({
    queryKey: ['collections-due-summary', queryParams],
    queryFn: () => API.get('/invoices/summary/due', { params: queryParams }),
  });

  return query;
};

export default useDueSummaryQuery;
